import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';
import { queryGet } from '../../../utils/queryClient';

export type RestoreSwipeResponse =
  paths['/api/v1/buddy_preferences/restore_swipe']['post']['responses'][200]['content']['application/json']['buddy_preference'];

export type BuddyPreferencesResponse =
  paths['/api/v2/buddy_preferences/me']['get']['responses'][200]['content']['application/json']['buddyProfileCard'];

export type AddBuddyPreferenceBody = NonNullable<
  paths['/api/v2/buddy_preferences']['post']['requestBody']
>['content']['application/json'];
export type AddBuddyPreferenceResponse =
  paths['/api/v2/buddy_preferences']['post']['responses'][200]['content']['application/json']['buddyPreference'];

export type CheckDuplicateSnsAccountBody = NonNullable<
  paths['/api/v2/buddy_preferences/sns_validation']['post']['requestBody']
>['content']['application/json'];
export type CheckDuplicateSnsAccountResponse =
  paths['/api/v2/buddy_preferences/sns_validation']['post']['responses'][200]['content']['application/json']['snsValidation'];

export type BuddyPreferenceResponse =
  paths['/api/v2/user_profiles/{user_profile_id}/buddy_preferences']['get']['responses'][200]['content']['application/json']['buddyProfileCard'];

export type RecommendBuddyListResponse =
  paths['/api/v2/buddy_preferences/recommend']['get']['responses'][200]['content']['application/json'];

export type GetRecommendBuddyListParams = {
  page?: number;
  perPage?: number;
};

export async function restoreSwipe(adUnitId: string): Promise<RestoreSwipeResponse> {
  const { data, error } = await client.POST('/api/v1/buddy_preferences/restore_swipe', {
    headers: authHeaders(),
    body: {
      ad_unit_id: adUnitId
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from restoreSwipe');

  return data.buddy_preference;
}

export async function getBuddyPreferences(): Promise<BuddyPreferencesResponse> {
  const { data, error } = await client.GET('/api/v2/buddy_preferences/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from getBuddyPreferences');

  return data.buddyProfileCard;
}

export async function addBuddyPreference(
  buddyPreference: AddBuddyPreferenceBody
): Promise<AddBuddyPreferenceResponse> {
  const { data, error } = await client.POST('/api/v2/buddy_preferences', {
    headers: authHeaders(),
    body: buddyPreference
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from addBuddyPreference');

  return data.buddyPreference;
}

export async function checkDuplicateSnsAccount(
  body: CheckDuplicateSnsAccountBody
): Promise<CheckDuplicateSnsAccountResponse> {
  const { data, error } = await client.POST('/api/v2/buddy_preferences/sns_validation', {
    headers: authHeaders(),
    body
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response from checkDuplicateSnsAccount');

  return data.snsValidation;
}

export async function getBuddyPreferenceByUserProfileId(
  userProfileId: string
): Promise<BuddyPreferenceResponse> {
  const { data, error } = await client.GET(
    '/api/v2/user_profiles/{user_profile_id}/buddy_preferences',
    {
      params: { path: { user_profile_id: userProfileId } },
      headers: authHeaders()
    }
  );
  if (error) throw error;
  if (!data) throw new Error('Empty response from getBuddyPreferenceByUserProfileId');

  return data.buddyProfileCard;
}

export async function getRecommendBuddyList(
  params: GetRecommendBuddyListParams = {}
): Promise<RecommendBuddyListResponse> {
  const { page = 1, perPage = 20 } = params;

  // swagger에 query params가 누락되어 openapi-fetch 타입이 query를 허용하지 않을 수 있어,
  // 해당 endpoint만 queryGet(직접 URL)로 페이지네이션을 처리합니다.
  const queryParams = new URLSearchParams({
    page: String(page),
    per_page: String(perPage)
  });

  const data = (await queryGet(
    `/api/v2/buddy_preferences/recommend?${queryParams.toString()}`
  )) as RecommendBuddyListResponse;

  if (!data) throw new Error('Empty response from getRecommendBuddyList');
  return data;
}